import { useSyncExternalStore } from 'react';

// Guarda a funcao de trigger fora do Redux: uma funcao (assincrona, nao
// serializavel) nunca deveria viver no estado do Redux, pois quebra o
// serializableCheck middleware (usado em dev para pegar bugs de persist).
// useSyncExternalStore da a mesma reatividade que o Redux dava via useSelector.
type ChartRequestTrigger = (() => void) | undefined;

let currentTrigger: ChartRequestTrigger;
const listeners = new Set<() => void>();

export function setChartRequestTrigger(trigger: ChartRequestTrigger) {
  currentTrigger = trigger;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): ChartRequestTrigger {
  return currentTrigger;
}

export function useChartRequestTriggerValue(): ChartRequestTrigger {
  return useSyncExternalStore(subscribe, getSnapshot);
}
